var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 108,
    viewBox: "0 0 105 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_2636)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.00391,
    y: 0.834961,
    width: 93.3333,
    height: 93.3333,
    rx: 26.6667,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.67057,
    y: 1.50163,
    width: 92,
    height: 92,
    rx: 26,
    stroke: "#D9D9D9",
    strokeWidth: 1.33333,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6693 53.3366C55.8909 53.3366 58.5026 50.7249 58.5026 47.5033C58.5026 44.2816 55.8909 41.6699 52.6693 41.6699C49.4476 41.6699 46.8359 44.2816 46.8359 47.5033C46.8359 50.7249 49.4476 53.3366 52.6693 53.3366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5026 50.4199V44.5866H75.5068L83.0318 37.0324L78.9193 32.9199L64.3359 47.5033L78.9193 62.0866L83.0318 57.9741L75.5068 50.4199H93.5026ZM49.7526 70.3408V88.3366H55.5859V70.3408L63.1401 77.8658L67.2526 73.7533L52.6693 59.1699L38.0859 73.7533L42.1984 77.8658L49.7526 70.3408ZM26.4193 32.9199L22.3068 37.0324L29.8318 44.5866H11.8359V50.4199H29.8318L22.3068 57.9741L26.4193 62.0866L41.0026 47.5033L26.4193 32.9199ZM55.5859 24.6658V6.66992H49.7526V24.6658L42.1984 17.1408L38.0859 21.2533L52.6693 35.8366L67.2526 21.2533L63.1401 17.1408L55.5859 24.6658Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_2636",
    x: 0.670573,
    y: 0.834961,
    width: 103.999,
    height: 106.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_2636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_2636",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3);
export default __webpack_public_path__ + "static/media/c3.8e9dd2b8b81f20695df89787b545749d.svg";
export { ForwardRef as ReactComponent };